module.exports = __webpack_public_path__ + "static/media/allGoods@2x.1db73fab.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_136/imgs/allGoods@2x.png
// module id = 1214
// module chunks = 0